// PRD-3334: the Hire page (Talent Network) filters a talent is shortlisted under, sent with the add so the
// shortlist entry keeps them (they reach Salesforce with the lead). A save from a card takes the list's
// filters as they are; a save from a profile takes those of the list the profile was opened from.

export interface ShortlistFilters {
  roles: string[];
  tools: string[];
  languages: string[];
}

const OPENED_KEY = "shortlistOpenedFilters";
/** Profiles remembered per tab, newest kept. */
const MAX_OPENED = 100;

/** Set while the Hire page list is on screen; null without filters or away from it. */
let listFilters: ShortlistFilters | null = null;

const hasAny = (f: ShortlistFilters) => !!(f.roles.length || f.tools.length || f.languages.length);

function readOpened(): Record<string, ShortlistFilters> {
  try {
    return JSON.parse(sessionStorage.getItem(OPENED_KEY) || "{}") || {};
  } catch {
    return {};
  }
}

export function setListFilters(filters: ShortlistFilters | null): void {
  listFilters = filters && hasAny(filters) ? { roles: [...filters.roles], tools: [...filters.tools], languages: [...filters.languages] } : null;
}

/** A card was opened: its profile shortlists under the list's filters (or none). */
export function rememberOpenedFilters(talentId: string): void {
  const { [talentId]: _old, ...rest } = readOpened();
  const next = listFilters ? { ...rest, [talentId]: listFilters } : rest;
  const kept = Object.fromEntries(Object.entries(next).slice(-MAX_OPENED));
  try {
    sessionStorage.setItem(OPENED_KEY, JSON.stringify(kept));
  } catch {
    // storage unavailable: the profile shortlists without filters
  }
}

/** The filters to send with a shortlist add; null when there were none. */
export function shortlistFiltersFor(talentId: string, from: "card" | "profile"): ShortlistFilters | null {
  return from === "card" ? listFilters : readOpened()[talentId] ?? null;
}
